/*@ngInject*/
const GetChecklistItemsRepository = function (baseSharedPromiseRepository) {

    let sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.getChecklistItems = function (submissionId) {
        let url = '/rest/Submission/' + submissionId + '/CheckListItems',
            cacheKey = submissionId;

        return this.get(cacheKey, url);
    };
};

angular.module('gw-um-submission')
    .service('getChecklistItemsRepository', GetChecklistItemsRepository);
